// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DistributionProfile.yaml
// Generated: 2026-06-25T16:43:33.493Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateDistributionProfile, UpdateDistributionProfile, DistributionProfile } from '@/types/finance/DistributionProfile';

/**
 * DistributionProfile Service
 * CRUD operations for DistributionProfile via the ABP API.
 */
export const distributionProfileService = new EntityService<DistributionProfile, CreateDistributionProfile, UpdateDistributionProfile>(
  '/api/finance/distributionprofile',
  'DistributionProfile',
);
